import axios from "axios";
import { Env } from "../enviroment/environment";
import authHeader from "./auth-header";

const API_URL = Env.CardHolderApiUrl;
const API_URL_CARD = Env.CardsApiUrl;
const API_URL_CARDHOLDER = Env.CardHolderApiUrl;
const API_URL_ACCOUNT = Env.IBANApiUrl;
const API_URL_BANK_ACCOUNT = Env.BankAccountApiUrl;
const getcardholderDetail = (CardHolderId) => {
  return axios
    .get(API_URL + "getcardholderDetail?CardHolderId=" + CardHolderId, {
      headers: authHeader()
    })
    .then((res) => {
      return res;
    });
};
const getibandetail = (accountId) => {
  return axios
    .post(API_URL_ACCOUNT + "getibandetail?accountId=" + accountId,{}, {
      headers: authHeader()
    })
    .then((res) => {
      return res;
    });
};
const GetAccountDetails = (userId) => {
  return axios
    .post(API_URL_BANK_ACCOUNT + "GetAccountDetails?userId=" + userId,{}, {
      headers: authHeader()
    })
    .then((res) => {
      return res;
    });
};
const getcorporateaccountdetails = (userId) => {
  return axios
    .post(API_URL_BANK_ACCOUNT + "getcorporateaccountdetails?userId=" + userId,{}, {
      headers: authHeader()
    })
    .then((res) => {
      return res;
    });
};
const updateCardHolderStatus = (userId, isActive) => {
  return axios
    .post(
      API_URL +
        "updateStatus?userId=" +
        userId +
        "&isActive=" +
        isActive,
      {},
      { headers: authHeader() }
    )
    .then((res) => {
      return res;
    });
};
const gettransactiondata = () => {
  return axios
    .post(API_URL + "getcardholderDetail", {}, { headers: authHeader() })
    .then((res) => {
      return res;
    });
};
const getCardDetail = (userId) => {
  return axios
    .get(API_URL + "getcarddetaildashboard?userId="+userId, {
      headers: authHeader(),
    })
    .then((response) => {
      return response;
    });
};
const suspendCard = (TokenId,OperatorUserId,UserIdCard,IsBlock,ClientId,Description,BlockAction,CardCurrency) => {
  return axios
    .post(
      API_URL_CARD + "blockunblockcard",
      {TokenId,OperatorUserId,UserIdCard,IsBlock,ClientId,Description,BlockAction,CardCurrency},
      {
        headers: authHeader(),
      }
    )
    .then((resp) => {
      return resp;
    });
};

const enableActivationProcess = (userId) => {
  return axios
    .post(
      API_URL_CARD +`reenableactivationprocess?userId=${userId}`
      ,
      {
        headers: authHeader(),
      }
    )
    .then((resp) => {
      return resp;
    });
};


const renameActivationProcessHandler = (userId) => {
  return axios
    .post( 
      API_URL_CARD + `resendactivationemail?userId=${userId}`,
      {
        headers: authHeader(),
      }
    )
    .then((resp) => {
      return resp;
    });
};

const unSuspendCard = (TokenId,OperatorUserId,UserIdCard,IsBlock,ClientId,Description,CardCurrency) => {
  return axios
    .post(
      API_URL_CARD + "blockunblockcard",
      {TokenId,OperatorUserId,UserIdCard,IsBlock,ClientId,Description,CardCurrency},
      {
        headers: authHeader(),
      }
    )
    .then((resp) => {
      return resp;
    });
};
const onEditCard = (FirstName,LastName,Address,City,Country,ZipCode,Userid, Email) => {
  return axios
    .post(
      API_URL + "editcardholderdetails",
      {FirstName,LastName,Address,City,Country,ZipCode,Userid, Email},
      {
        headers: authHeader(),
      }
    )
    .then((resp) => {
      return resp;
    });
};
const checkorderstatus = (userId) => {
  return axios
    .post( 
      API_URL + `checkorderstatus?userId=${userId}`,
      {
        headers: authHeader(),
      }
    )
    .then((resp) => {
      return resp;
    });
};
const getdeclinetransactioncount = (TokenId , CardHolderName , ClientId , PageSize , StartIndex , PageNo,FetchAll  ) => {
  return axios
    .post(
      API_URL_CARDHOLDER + "getdeclinetransactioncount",
      {
        TokenId , CardHolderName , ClientId , PageSize , StartIndex , PageNo,FetchAll
      },
      { headers: authHeader() }
    )
    .then((resp) => {
      return resp;
    });
};
const getdeclineauthtransactioncount = (TokenId , CardHolderName , ClientId , PageSize , StartIndex , PageNo,FetchAll  ) => {
  return axios
    .post(
      API_URL_CARDHOLDER + "getzeroauthtransactioncount",
      {
        TokenId , CardHolderName , ClientId , PageSize , StartIndex , PageNo,FetchAll
      },
      { headers: authHeader() }
    )
    .then((resp) => {
      return resp;
    });
};
const getnegativecardbalances = (TokenId , CardHolderName , ClientId , PageSize , StartIndex , PageNo,FetchAll,DateFrom,DateTo,Amount  ) => {
  return axios
    .post(
      API_URL_CARDHOLDER + "getnegativecardbalances",
      {
        TokenId , CardHolderName , ClientId , PageSize , StartIndex , PageNo,FetchAll,DateFrom,DateTo,Amount
      },
      { headers: authHeader() }
    )
    .then((resp) => {
      return resp;
    });
};
const cardHolderService = {
  getcardholderDetail,
  updateCardHolderStatus,
  gettransactiondata,
  getCardDetail,
  suspendCard,
  unSuspendCard,
  onEditCard,
  enableActivationProcess,
  renameActivationProcessHandler,
  checkorderstatus,
  getibandetail,
  GetAccountDetails,
  getcorporateaccountdetails,
  getdeclinetransactioncount,
  getnegativecardbalances,
  getdeclineauthtransactioncount
};
export default cardHolderService;
